<template>
  <div>
    <form class="userForm widget-scroll" v-on:submit="sendUserInfo()">
      <h2 class="userForm-title">{{ settings.form_title }}</h2>
      <label v-if="showEmail">{{ settings.form_email }}</label>
      <input v-if="showEmail" type="email" v-model="userInfo.email" class="userForm-input"
             @input="addToValidation($event.target, 'email')" v-bind:placeholder="settings.form_placeholder_email"
             required>
      <label v-bind:class="{hiddenEmail: showEmail === false}">{{ settings.form_name }}</label>
      <input type="text" v-model="userInfo.first_name" v-bind:class="{hiddenEmail: showEmail === false}"
             class="userForm-input" v-on:input="addToValidation($event.target, 'first_name')"
             v-bind:placeholder="settings.form_placeholder_name" required>
      <label>{{ settings.form_last_name }}</label>
      <input type="text" v-model="userInfo.last_name" class="userForm-input"
             v-on:input="addToValidation($event.target, 'last_name')"
             v-bind:placeholder="settings.form_placeholder_last_name">
      <label v-if="showPhone">{{ settings.form_phone }}</label>
      <input type="tel" v-model="userInfo.phone" v-if="!phoneChanged && showPhone" autocomplete="new-password"
             class="userForm-input" @click="changePhoneFields()" v-bind:placeholder="settings.form_placeholder_phone">
      <div class="phone-input" v-if="phoneChanged && showPhone">
        <v-select v-model="selectedCountryCode" class="phone-input__codes" taggable :options="countryCodes">
          <template #search="{attributes, events}">
            <input
              style="border: 1px solid transparent; height: auto"
              class="vs__search"
              :required="!selectedCountryCode"
              v-bind="attributes"
              v-on="events"
            />
          </template>
        </v-select>
        <input type="tel" v-model="userInfo.phone" autocomplete="new-password" maxlength="10"
               onkeypress="return event.charCode >= 48 && event.charCode <= 57"
               class="userForm-input phone-input__number" v-on:input="addToValidation($event.target, 'phone')"
               v-bind:placeholder="settings.form_placeholder_phone" required>
      </div>
      <button type="submit" v-bind:class="{hiddenPhone: showPhone === false}" class="userForm-button"
              v-bind:style="{ backgroundColor: settings.theme_color, color: settings.button_font }">
        {{ settings.form_save }}
      </button>
    </form>
    <div v-bind:class="{ 'ask-widget-overlay' : preloader, 'hidden-overlay' : !preloader }">
      <div class="ask-widget-preloader"></div>
    </div>
  </div>
</template>

<script>
import {getUser} from '../services/getUser'
import {globalState, serverBus} from '../main'
import Vue from 'vue'
import vSelect from 'vue-select'
// import DeviceDetector from 'device-detector-js'
const axios = require('axios')
Vue.component('v-select', vSelect)

export default {
  name: 'UserDataForm',
  mixins: [getUser],
  data () {
    return {
      liveChatScript: '',
      userInfoLS: JSON.parse(localStorage.getItem('userInfoLS')) || {},
      userInfo: {},
      settings: {},
      showEmail: true,
      showPhone: true,
      arrayToValid: [],
      validated: true,
      preloader: false,
      phoneChanged: false,
      nameChanged: false,
      countryCodes: [],
      selectedCountryCode: '',
      validCodeOnEmojj: /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g
    }
  },
  methods: {
    addToValidation (elem, name) {
      switch (name) {
        case 'email':
          this.userInfo.email = elem.value.replaceAll(this.validCodeOnEmojj, '')
          break
        case 'first_name':
          this.userInfo.first_name = elem.value.replaceAll(this.validCodeOnEmojj, '')
          break
        case 'last_name':
          this.userInfo.last_name = elem.value.replaceAll(this.validCodeOnEmojj, '')
          break
        case 'phone':
          this.userInfo.phone = elem.value.replaceAll(this.validCodeOnEmojj, '')
          break
        default:
          break
      }

      if (!this.arrayToValid.includes(elem)) {
        this.arrayToValid.push(elem)
      }
    },
    changePhoneFields () {
      if (this.showPhone) {
        this.phoneChanged = true
        this.userInfo.phone = ''
        let ask = {
          brand: this.ask.brand
        }

        axios
          .post(this.ask.url + '/api/ask/' + this.settings.api_salt + '/get-phone-code', {ask})
          .then(response => {
            response.data.data.forEach(item => {
              this.countryCodes.push(item.code)
            })
          })
      }
    },
    validateField (item) {
      switch (item.type) {
        case 'email':
          // eslint-disable-next-line
          var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          var reEm = this.validCodeOnEmojj
          if (!re.test(item.value) && !reEm.test(item.value)) {
            item.classList.add('novalid')
            return false
          } else {
            item.classList.remove('novalid')
          }
          break
        case 'text':
          // eslint-disable-next-line
          var re2 = /(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7BF\uA7C2-\uA7C6\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB67\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDEC0-\uDEEB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D])/
          if (item.value.length <= 2 || !re2.test(item.value)) {
            item.classList.add('novalid')
            return false
          } else {
            item.classList.remove('novalid')
          }
          break
        case 'tel':
          if (item.value.length > 6) {
            item.classList.remove('novalid')
          } else {
            item.classList.add('novalid')
            return false
          }
      }
    },
    userFormInfo () {
      localStorage.removeItem('dataHistory')
      localStorage.removeItem('dataTotalCategory')
      // let isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)
      // let isOpera = !!window.opr || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0
      let ask = {
        action: 'open_widget',
        user_id: this.ask.user_id,
        brand: this.ask.brand,
        url: this.ask.url,
        ip: this.ask.ip,
        lang: this.ask.lang,
        user_agent: navigator.userAgent,
        device: '',
        os: '',
        model: '',
        button_name: this.$linkedButton
      }
      // if (isChrome || isOpera) {
      //   const deviceDetector = new DeviceDetector()
      //   const device = deviceDetector.parse(navigator.userAgent)
      //   ask.device = device.device.type
      //   ask.os = device.os.name + ' ' + device.os.version
      //   if (device.device.type === 'tablet' || device.device.type === 'smartphone') ask.model = device.device.brand + ' ' + device.device.model
      // }
      axios
        .post(this.ask.url + '/api/ask/' + this.settings.api_salt + '/user-form-info', {ask})
        .then(response => {
          if (response.data.user_id) {
            if (Object.keys(this.userInfoLS).length !== 0) {
              let firstName = response.data.first_name ? response.data.first_name : this.userInfoLS.data.first_name
              let lastName = response.data.last_name ? response.data.last_name : this.userInfoLS.data.last_name
              this.userInfo = {...response.data, first_name: firstName, last_name: lastName}
            } else {
              this.userInfo = response.data
            }
          } else {
            if (Object.keys(this.userInfoLS).length !== 0) {
              this.userInfo = {
                first_name: this.userInfoLS.data.first_name,
                last_name: this.userInfoLS.data.last_name
              }
            } else {
              this.userInfo = {}
            }
          }

          if (response.data.hasOwnProperty('first_name')) {
            this.nameChanged = response.data.first_name.length === 0
          }
          this.$ask.lead_profile_url = response.data.lead_profile_url
          Vue.prototype.$userUid = response.data.uid
          localStorage.setItem('getUuid', response.data.uid)
          // this.checkCookies()

          if (this.$settings.use_widget === 0) {
            if (this.$settings.widget_type_code === 'live_chat') {
              var script = document.createElement('script')
              // eslint-disable-next-line no-useless-escape
              script.innerHTML = `window.__lc = window.__lc || {};window.__lc.license = ${this.$settings.livechat_code}; window.__lc.chat_between_groups = false; window.__lc.group = "${this.$settings.chat_id}";;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can\'t use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))\n`
              this.liveChatScript = script.innerHTML
              document.body.appendChild(script)

              // eslint-disable-next-line no-undef
              LiveChatWidget.on('ready', function () {
                let liveChatHistory = {
                  initializeScript: script.innerHTML,
                  userInfo: {}
                }
                globalState.visibleOfLiveChat = true
                localStorage.setItem('liveChatHistory', JSON.stringify(liveChatHistory))
                localStorage.setItem('getExpireDateOfLiveChat', new Date())
              })
              // eslint-disable-next-line no-undef
              LiveChatWidget.on('ready', function () {
                localStorage.setItem('statusLiveChat', 'maximized')
                // eslint-disable-next-line no-undef
                LiveChatWidget.on('visibility_changed', function (data) {
                  localStorage.setItem('statusLiveChat', data.visibility)
                })

                // eslint-disable-next-line no-undef
                LiveChatWidget.on('customer_status_changed', function (data) {
                  if (data.status === 'browsing') {
                    localStorage.removeItem('liveChatHistory')
                    localStorage.removeItem('statusLiveChat')
                    localStorage.removeItem('getExpireDateOfLiveChat')
                  }
                })
              })

              if (this.userInfo.first_name === undefined) {
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('set_customer_name', ' ')
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('set_customer_email', ' ')
              } else {
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('set_customer_name', `${this.userInfo.first_name}`)
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('set_customer_email', this.userInfo.email)
              }
              if (this.userInfo.currency === undefined) {
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('update_session_variables', {
                  currency: ''
                })
              } else {
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('update_session_variables', {
                  currency: this.userInfo.currency
                })
              }
              if (this.userInfo.email_verified === undefined) {
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('update_session_variables', {
                  email_verified: ''
                })
              } else {
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('update_session_variables', {
                  email_verified: this.userInfo.email_verified
                })
              }
              if (this.userInfo.is_vip === undefined) {
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('update_session_variables', {
                  is_vip: ''
                })
              } else {
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('update_session_variables', {
                  is_vip: this.userInfo.is_vip
                })
              }
              if (this.userInfo.appeals === undefined) {
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('update_session_variables', {
                  appeals: ''
                })
              } else {
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('update_session_variables', {
                  appeals: this.userInfo.appeals
                })
              }
              if (this.userInfo.tags === undefined) {
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('update_session_variables', {
                  tags: ''
                })
              } else {
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('update_session_variables', {
                  tags: this.userInfo.tags
                })
              }
              if (this.userInfo.phone_verified === undefined) {
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('update_session_variables', {
                  phone_verified: ''
                })
              } else {
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('update_session_variables', {
                  phone_verified: this.userInfo.phone_verified
                })
              }
              if (this.userInfo.lead_profile_url === undefined) {
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('update_session_variables', {
                  profile_url: ''
                })
              } else {
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('update_session_variables', {
                  profile_url: this.userInfo.lead_profile_url
                })
              }
              if (this.userInfo.brand_id === undefined) {
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('update_session_variables', {
                  brand_id: ''
                })
              } else {
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('update_session_variables', {
                  brand_id: this.ask.brand
                })
              }
              if (this.userInfo.user_id === undefined) {
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('update_session_variables', {
                  player_id: ''
                })
              } else {
                // eslint-disable-next-line no-undef
                LiveChatWidget.call('update_session_variables', {
                  player_id: 'PLAYER-' + this.userInfo.user_id
                })
              }
              // eslint-disable-next-line no-undef
              LiveChatWidget.call('maximize')
              // eslint-disable-next-line no-undef
              // LiveChatWidget.on('visibility_changed', data => {
              // sessionStorage.setItem('visibility_changed', data.visibility)
              // })
            } else if (this.settings.widget_type_code === 'live_agent') {
              const sendFieldsForChatSystem = {
                name: this.userInfo.first_name ? this.userInfo.first_name : '',
                brand: this.ask.brand,
                currency: this.userInfo.currency,
                email_verified: this.userInfo.email_verified,
                phone_verified: this.userInfo.phone_verified,
                uuid: this.$registered ? this.ask.user_id : 0,
                lead_profile_url: this.$registered ? this.ask.lead_profile_url : '',
                prechat_question: '',
                is_vip: this.userInfo.is_vip
              }
              let messageParams = ''

              for (var key in sendFieldsForChatSystem) {
                messageParams += `${key}: ${sendFieldsForChatSystem[key]} \n`
              }

              var scriptAgent = document.createElement('script')
              scriptAgent.innerHTML = `(function(d, src, c) { var t=d.scripts[d.scripts.length - 1],s=d.createElement('script');s.id='la_x2s6df8d';s.defer=true;s.src=src;s.onload=s.onreadystatechange=function(){var rs=this.readyState;if(rs&&(rs!='complete')&&(rs!='loaded')){return;}c(this);};t.parentElement.insertBefore(s,t.nextSibling);})(document,'https://${this.settings.liveagent_company_name}.ladesk.com/scripts/track.js',function(e){ LiveAgent.createButton('${this.settings.chat_id}', e, ${JSON.stringify(messageParams)}); });`
              document.body.appendChild(scriptAgent)
            }
          }
          if (!this.userInfo.phone || this.userInfo.phone.length > 15 || this.userInfo.phone.length < 10) this.changePhoneFields()
        })
    },
    sortObject (obj) {
      return Object.keys(obj).sort().reduce(function (result, key) {
        result[key] = obj[key]
        return result
      }, {})
    },
    sendUserInfo () {
      this.preloader = true
      event.preventDefault()
      this.validated = true
      this.arrayToValid.forEach(e => {
        if (this.validateField(e) === false) {
          this.validated = false
          this.preloader = false
        }
      })
      if (this.validated) {
        let date = new Date()
        localStorage.setItem('userInfoLS', JSON.stringify({
          data: {
            first_name: this.userInfo.first_name,
            last_name: this.userInfo.last_name
          },
          // 30 days - 1000 * 60 * 60 * 24 * 30 = 2592000000
          expires: date.getTime() + 2592000000
        }))
        if (this.selectedCountryCode) {
          this.userInfo.phone_code = this.selectedCountryCode
        }
        let ask = {
          action: 'save_info',
          user_id: this.ask.user_id,
          brand: this.ask.brand,
          name: this.userInfo.first_name,
          surname: this.userInfo.last_name,
          phone_code: this.userInfo.phone_code,
          token: this.userInfo.token,
          name_changed: this.ask.brand === 'supergra' ? false : this.nameChanged,
          uid: this.$userUid
        }
        if (this.showEmail) ask.email = this.userInfo.email
        if (this.showPhone) ask.phone = this.userInfo.phone
        Vue.prototype.$lastClick = new Date()
        axios
          .post(this.ask.url + '/api/ask/' + this.settings.api_salt + '/feedback-user-statistic', {ask})
          .then(response => {
            Vue.prototype.$userInfo = this.userInfo
            delete ask.uid
            var d = new Date()
            d.setTime(d.getTime() + (60 * 60 * 1000))
            var expires = 'expires=' + d.toUTCString()
            document.cookie = 'askUser' + '=' + JSON.stringify(ask) + ';' + expires + ';path=/'
            this.preloader = false
            serverBus.$emit('openCategories')
          })
      }
    },
    checkCookies () {
      let cookie = this.getCookie('askUser')
      if (cookie) {
        let ask = JSON.parse(cookie)
        this.userInfo.email = ask.email
        this.userInfo.first_name = ask.name
        this.userInfo.last_name = ask.surname
        if (ask.phone_code) {
          this.userInfo.phone = ask.phone_code + ask.phone
        } else {
          this.userInfo.phone = ask.phone
        }
      }
    },
    getCookie (name) {
      var matches = document.cookie.match(new RegExp(
        // eslint-disable-next-line
        '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'))
      return matches ? decodeURIComponent(matches[1]) : undefined
    }
  },
  mounted () {
    this.settings = this.$settings
    if (this.settings.dont_show_email === 1 && this.$registered === false) this.showEmail = false
    if (this.settings.dont_show_phone === 1 && this.$registered === false) this.showPhone = false
    this.ask = this.$ask
    this.userFormInfo()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserDataForm.vue